module dg.navigation {

    export interface IExportsListOptions {
        title: string
        /** When set, export links whose mediaType matches any of these are omitted (link may still exist on the query for other UI, e.g. custom handlers). */
        excludeMediaTypes?: string[]
    }

    class ExportsListController {

        public exportLinks: restfulApi.Link[];
        public links: restfulApi.Links;
        public query: dg.domain.queries.ListQuery<dg.domain.IDomainObject>;
        public exportTitle: string;
        public options: IExportsListOptions;

        public constructor(
            private navigationService: NavigationService,
            private modalService: dg.modals.ModalService,
            private $filter: dgUtils.IFilterService
        ) {

        }

        public export = (link: dg.restfulApi.Link) => {

            this.navigationService.navigate(link, this.query);
            //this.modalService.open({
            //    controller: dg.actions.ExportInvokerController,
            //    template: '<export-invoker form-editor query="$resolve.query" link="$resolve.link"></export-invoker>',
            //    resolve: {
            //        query: this.query,
            //        link: link
            //    }
            //})
            //.result.then((result) => {
            //    //if (angular.isDefined(scope.onSuccess)) {
            //    //    scope.onSuccess();
            //    //}
            //}, (error) => {
            //    //if (angular.isDefined(scope.onError)) {
            //    //    scope.onError();
            //    //}
            //});
        };

        $onInit = () => {
            this.exportLinks = this.$filter('dgLinksByRel')(this.links, [dg.restfulApi.DG_LINK_RELS.export, dg.restfulApi.DG_LINK_RELS.external]);
            this.exportLinks = this.exportLinks.filter(v => !v.disabledReason);
            if (this.options && this.options.excludeMediaTypes && this.options.excludeMediaTypes.length) {
                let exclude = this.options.excludeMediaTypes;
                this.exportLinks = this.exportLinks.filter(l => exclude.indexOf(l.mediaType) === -1);
            }

            let defaultOptions: IExportsListOptions = { title: "Download" };
            this.options = dgUtils.ObjectHelperService.mergeDeep(defaultOptions, this.options);
        }

    }

    angular.module('dg.navigation').component('exportsList', {
        bindings: {
            query: '<?',
            links: '<',
            options: '<?'
        },
        controller: ExportsListController,
        templateUrl: '/digmo/src/navigation/exports-list.html'
    });
}